import { world } from '../../languages';
import { AVAILABLE_WORLDS } from '../../languages/constants';
import schoolAccount from '../school-account';

export const isSchoolPrice = (user: User, material: Material) => {
    return Boolean(
        world === AVAILABLE_WORLDS.DE &&
            schoolAccount.isVerifiedUser(user) &&
            !schoolAccount.isAdmin(user) &&
            !material.hasFixedPrice
    );
};

export const hasACL = (materialInfo: Material): boolean => Boolean(materialInfo.hasAclFree || materialInfo.aclId);
